import { render, staticRenderFns } from "./RegattaAdd.vue?vue&type=template&id=754276b9&scoped=true&"
import script from "./RegattaAdd.vue?vue&type=script&lang=js&"
export * from "./RegattaAdd.vue?vue&type=script&lang=js&"
import style0 from "./RegattaAdd.vue?vue&type=style&index=0&id=754276b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754276b9",
  null
  
)

export default component.exports